import api from './httpService';

export const addCoachTypeService = async (payload: any) => {
    const response = await api.post('/coachType', payload); // assuming you're using axios
    return response.data;
};

export const getCoachTypeService = async () => {
    const response = await api.get("/coachType")
    return response.data;
}
export const updateCoachTypeService = async (id: string, data: any) => {
    const response = await api.put(`/coachType/${id}`, data); // Make sure data contains what to update
    return response.data;
};
